import styles from './tableToolbarButtons.module.css';

const TableToolbarButtons = ({ children }) => {
  return (
    <div id="toolbar-buttons" className={styles.container}>
      {children}
    </div>
  );
};

export default TableToolbarButtons;
